<script>
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer
  },
  data() {
    return {
      userData: {
        staffId: undefined,
        name: undefined,
        phone: undefined,
        role: undefined,
        gender: undefined
      },
      searchData: {
        operateType: undefined
      },
      dateRange: undefined,
      pageCount: 0,
      activePage: 1,
      tableData: [],
      searchArray: [
        {
          label: "医生：",
          keyName: "doctorName",
          type: "text",
          value: ""
        },
        {
          label: "状态：",
          keyName: "operateType",
          type: "radio",
          value: "",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "出售",
              keyName: "PAY"
            },
            {
              label: "退款",
              keyName: "REFUND"
            }
          ]
        }
      ],
      buttonArray: [
        {
          text: "最近一周",
          key: "week"
        },
        {
          text: "最近30天",
          key: "month"
        },
        {
          text: "最近90天",
          key: "ninety"
        }
      ],
      exportSalesData: false,
      exportForm: {
        dataRange: []
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1,
        size: 10,
        sort: "createdAt,DESC"
      };
      for (let key in this.searchData) {
        if (this.searchData[key]) {
          params[key] = this.searchData[key];
        }
      }

      if (this.dateRange && this.dateRange[0]) {
        params.start = this.dateRange[0];
      }
      if (this.dateRange && this.dateRange[1]) {
        params.end = this.dateRange[1];
      }
      const stationId = this.$route.params.accountId;
      const result = await this.$http.GetStationSalesPerformanceDetail(
        stationId,
        params
      );
      if (result) {
        const staffInfo = {
          stationId: result.stationId,
          stationName: result.stationName,
          location: result.location,
          totalSalesCourse: result.totalSalesCourse,
          totalSalesAmount: result.totalSalesAmount
        };
        this.userData = staffInfo;
        if (result.sales && result.sales.content) {
          this.pageCount = result.sales.totalPages;
          this.tableData = result.sales.content.map(o => {
            o.buyAt = moment(o.createdAt).format("YYYY-MM-DD HH:mm");
            o.status = o.operateType === "PAY" ? (o.complimentary ? "赠送" : "购买") : "退款";
            o.totalPrice = `${(
              parseFloat(o.courseCount) * parseFloat(o.unitPrice)
            ).toFixed(0)} 元`;
            return o;
          });
        }
      }
    },
    onSearch(data) {
      this.activePage = 1;
      this.loadData();
    },
    onExport() {
      this.exportSalesData = true;
      this.exportForm = {
        dataRange: []
      };
    },
    onSearchChange(data) {
      this.searchData = data;
    },
    handleCurrentChange(val) {
      this.activePage = val;
      this.loadData();
    },
    onOperationClick(row, key) {
      switch (key) {
        case "month":
          this.dateRange = [
            moment()
              .subtract(30, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "ninety":
          this.dateRange = [
            moment()
              .subtract(90, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "week":
          this.dateRange = [
            moment()
              .subtract(6, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
      }
    },
    async confirmExport() {
      if (this.exportForm.dataRange[0] && this.exportForm.dataRange[1]) {
        const params = {
          start: this.exportForm.dataRange[0],
          end: this.exportForm.dataRange[1]
        };
        const result = await this.$http.getExportSalesData(
          this.$route.params.accountId,
          params
        );
        console.log("result", result);
        const link = document.createElement("a");
        const blob = new Blob([result], {
          type: "application/vnd.ms-excel"
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `销售数据.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.exportSalesData = false;
      } else {
        this.$message.warning("请先选择时间段！");
      }
    }
  }
};
</script>
<template>
  <div class="salesManagementDetail">
    <!-- <el-card class="box-card basicInfo" shadow="never">
      <div slot="header" class="clearfix">
        <span class="cardTitleText">基本信息</span>
      </div>
      <div class="text item">
        <el-row :gutter="24">
          <el-col :span="5">
            <div class="grid-content bg-purple">机构Id： {{userData.stationId}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">机构名称： {{userData.stationName}}</div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple">地址： {{userData.location}}</div>
          </el-col>
        </el-row>
      </div>
    </el-card>-->
    <operationDialog
      title="导出数据"
      :center="true"
      width="400px"
      custom-class="customClass"
      :Visible="exportSalesData"
      @close="exportSalesData = false"
      @confirm="confirmExport"
      btnText="导出"
    >
      <el-date-picker
        v-model="exportForm.dataRange"
        type="daterange"
        align="right"
        unlink-panels
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      ></el-date-picker>
    </operationDialog>
    <el-card class="box-card withoutBorderBottom" shadow="never">
      <el-row :gutter="24">
        <el-col :span="18">
          <div class="TextGroup">
            <div class="dataSearch">
              <span>销售疗程时间筛选：</span>
              <el-date-picker
                v-model="dateRange"
                @keyup.enter.native="onSearch"
                size="medium"
                class="dateRange"
                type="daterange"
                range-separator="至"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <textButtonGroup
                class="dataButton"
                :buttonArray="buttonArray"
                @onOperationClick="onOperationClick"
                @keyup.enter.native="onSearch"
              />
              <el-button type="primary" class="searchButton" @click="onSearch" size="mini">搜索</el-button>
              <el-button class="searchButton" type="primary" @click="onExport" size="mini">导出</el-button>
            </div>
          </div>
          <searchFormNew
            class="searchForm"
            @onChange="onSearchChange"
            :searchItemArray="searchArray"
            @onSearch="onSearch"
          />
        </el-col>
        <el-col :span="6">
          <div class="searchLocation">
            <div>
              <div class="saleNumberTitle">销售总疗程</div>
              <div class="saleNumber">{{userData.totalSalesCourse}}</div>
            </div>
            <div class="line"></div>
            <div>
              <div class="saleNumberTitle">销售总金额</div>
              <div class="saleNumber">{{userData.totalSalesAmount}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        class="AgencyRangeTable"
        :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
        :cell-style="{'padding-left': '5px'}"
      >
        <el-table-column prop="buyAt" align="left" label="操作日期" width="150"></el-table-column>
        <el-table-column prop="status" align="left" label="状态" width="80"></el-table-column>
        <el-table-column prop="courseCount" align="left" label="销售疗程" width="95"></el-table-column>
        <el-table-column prop="totalPrice" align="left" label="应支付金额(元)" width="125"></el-table-column>
        <el-table-column prop="patientName" align="left" label="患者姓名" min-width="115"></el-table-column>
        <el-table-column prop="phone" align="left" label="患者手机号" width="125"></el-table-column>
        <el-table-column prop="stationName" align="left" label="所属医疗机构" min-width="120"></el-table-column>
        <el-table-column prop="doctorName" align="left" label="主治医生" min-width="120"></el-table-column>
      </el-table>
      <PagenationContainer v-if="pageCount > 1">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="activePage"
          :page-count="pageCount"
          layout="prev, pager, next, jumper"
        ></el-pagination>
      </PagenationContainer>
    </el-card>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.salesManagementDetail {
  background-color: #f5f6f7;

  .basicInfo {
    margin: 15px 0;

    .grid-content {
      padding: 15px 0px;
      border-radius: 4px;
    }

    .el-pagination {
      text-align: center;
      margin-top: 10px;
    }

    .text {
      font-size: 14px;
      padding-top: 0px;
    }
    .genderStyle {
      // width: 11px;
      height: 17.5px;
      margin-bottom: -2px;
    }
    .item {
      margin-bottom: 18px;

      .checkBoxLabel {
        color: #303133;

        .el-checkbox__input.is-disabled + span.el-checkbox__label {
          color: #303133;
        }
      }
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both;
    }

    .cardTitleText {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .TextGroup {
    display: flex;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }

    .dataButton {
      margin-left: 10px;
      margin-right: 15px;
      display: inline-block;
    }
    .searchButton {
      border-color: #00c1de;
      background-color: #00c1de;
    }
  }
  .searchLocation {
    display: flex;
    text-align: center;
    .line {
      width: 1px;
      height: 40px;
      background-color: #e4e8eb;
      margin-left: 25px;
      margin-right: 25px;
    }
    .saleNumberTitle {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 22px;
    }
    .saleNumber {
      font-size: 25px;
      font-family: HelveticaNeue;
      color: rgba(0, 0, 0, 0.85);
      line-height: 38px;
    }
  }
  .AgencyRangeTable {
    width: 98%;
    margin: auto;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }

  .withoutBorderBottom {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/salesManagement/institutionsDetail.vue